import Vue from 'vue'
import './components'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

Vue.use( CKEditor );
Vue.use(VuePlyr, {
  plyr: {}
})

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  timeout: 3048,
});

import { LMap, LTileLayer, LMarker ,LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polygon', LPolygon)
Vue.component('l-control', LControl)
Vue.component('l-icon', LIcon)
Vue.component('v-select', vSelect)

import './plugins/fontawesome'
import './plugins/axios'
import './plugins/http_client'
import 'viewerjs/dist/viewer.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import 'leaflet/dist/leaflet.css';
import vClickOutside from 'v-click-outside'
import LPolygon from "vue2-leaflet/dist/components/LPolygon";
import LIcon from "vue2-leaflet/dist/components/LIcon";

// Plugin VUE TEL MASK EXT
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

import FunctionalCalendar from 'vue-functional-calendar';
Vue.use(FunctionalCalendar, {
  dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
});

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask);
import VueViewer from 'v-viewer'
Vue.use(VueViewer)

Vue.use(require('vue-moment'));
Vue.use(vClickOutside)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    const token = localStorage.getItem('token')
    if (token)
        store.dispatch('setToken', token).then(r => {})
  }
}).$mount('#app')
